import React, {useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useStyles} from './AccountVoicemail.utils';
import AccountControlPanel from '../AccountControlPanel/AccountControlPanel';
import Header from '../../components/ListViewHeader/Header';
import VoicemailList from "../Voicemails/VoicemailList";
import classNames from 'classnames';
import {useSelector} from 'react-redux';
import {ReduxState} from '../../store/types';
import {ServiceFeatureName} from '../../store/types/ServiceFeature';
import {YesNo} from '../../store/types/CallScreening';

const AccountVoicemail = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [filteredCount, setFilteredCount] = useState<number>(0);

    const {accountDetails} = useSelector((state: ReduxState) => state.accountControlPanel);

    const unifiedMessagingEnabled = useMemo(() => {
        return accountDetails?.service_features?.find(e => e.name == ServiceFeatureName.UnifiedMessaging && e.effective_flag_value == YesNo.Yes) != undefined;
    }, [accountDetails?.service_features]);

    const totalComponent = (total: number) => (
        <span className={classes.totalCount}>{total} {t('common:total')}</span>
    );

    return (
        <div className={classes.mainDashboardContainer}>
            <div className={classes.header}>
                <Header title={t('screens:voicemails.voicemail')} hideTotal customSlot={unifiedMessagingEnabled ? totalComponent(filteredCount) : undefined}/>
                <div className={classes.rightSection}>
                    <AccountControlPanel />
                </div>
            </div>


            <div className={classNames(classes.voicemailListContainer,classes.scrollable)}>
                <VoicemailList onFilteredCountChange={setFilteredCount}/>
            </div>
        </div>
    );
};

export default AccountVoicemail;
